const bannedWords = [
  "anjim",
  "anjing",
  "anjir",
  "anjrit",
  "anjrot",
  "asu",
  "babi",
  "bacot",
  "bajingan",
  "banci",
  "bangke",
  "bangor",
  "bangsat",
  "bego",
  "bejad",
  "bencong",
  "bodat",
  "bugil",
  "bundir",
  "bunuh",
  "burik",
  "burit",
  "cawek",
  "cemen",
  "cipok",
  "cium",
  "colai",
  "coli",
  "colmek",
  "cukimai",
  "cukimay",
  "culun",
  "cumbu",
  "dancuk",
  "dick",
  "dildo",
  "encuk",
  "gay",
  "gei",
  "gembel",
  "gey",
  "gigolo",
  "goblog",
  "goblok",
  "hencet",
  "hentai",
  "idiot",
  "jablai",
  "jablay",
  "jancok",
  "jancuk",
  "jangkik",
  "jembut",
  "jilat",
  "jingan",
  "kampang",
  "keparat",
  "kimak",
  "kirik",
  "klentit",
  "klitoris",
  "konthol",
  "kontol",
  "koplok",
  "kunyuk",
  "kutang",
  "kutis",
  "kwontol",
  "lonte",
  "maho",
  "masturbasi",
  "matane",
  "memek",
  "modar",
  "modyar",
  "mokad",
  "najis",
  "nazi",
  "ndhasmu",
  "nenen",
  "ngentot",
  "ngolom",
  "ngulum",
  "nigga",
  "nigger",
  "onani",
  "orgasme",
  "pantat",
  "pantek",
  "pecun",
  "peli",
  "pentil",
  "pepek",
  "perek",
  "perkosa",
  "porno",
  "pukimak",
  "qontol",
  "selangkang",
  "sempak",
  "senggama",
  "setan",
  "setubuh",
  "silet",
  "silit",
  "sinting",
  "sodomi",
  "telaso",
  "tete",
  "titit",
  "togel",
  "toket",
  "tolol",
  "tusbol",
  "urin",
  "yateam",
];

export default bannedWords;
